import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { FundingSearchStatus, toLabel } from 'enums/funding-search-status';

const FundingSearchRecord = Record({
  id: 0,
  amount: '',
  period: 0,
  status: FundingSearchStatus.submitted,
  productType: 0,
  companyName: '',
  profileCompletion: '',
  fundingSearchId: 0,
  governmentBacked: false,
  authorUserName: '',
  manager: {},
  created: new Date(0),
  lastChangeDate: new Date(0),
  allMatchesCount: 0,
  statusMatchesCount: 0,
  isManager: false,
  isFollower: false,
  isTeamSearch: false,
  private: false,
  dueCount: 0,
});

export default class FundingSearchLegacy extends FundingSearchRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject === undefined) {
      return undefined;
    }

    const mapProperties = {
      created: Hydrator.timestamp2Date,
      lastChangeDate: Hydrator.timestamp2Date,
      profileCompletion: Hydrator.toFloat,
      allMatchesCount: Hydrator.toInt,
      statusMatchesCount: Hydrator.toInt,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new FundingSearchLegacy(hydrated);
  }

  get searchManagerName() {
    return this.getIn(['manager', 'name']);
  }

  get reviewedPercentage() {
    if (this.allMatchesCount === 0) {
      return 0;
    }

    return (this.statusMatchesCount / this.allMatchesCount) * 100;
  }

  get statusAsLabel() {
    return toLabel(this.status);
  }

  get completion() {
    return Math.floor(this.profileCompletion);
  }

  get completionLabel() {
    const { completion } = this;

    if (completion >= 0 && completion < 40) {
      return 'More work to do';
    }

    if (completion >= 40 && completion < 65) {
      return 'Halfway there';
    }

    if (completion >= 65 && completion < 99) {
      return 'Almost there';
    }

    if (completion >= 99) {
      return 'Complete';
    }

    return '';
  }

  get isStatusPreRelease() {
    return (
      this.status === FundingSearchStatus.incomplete ||
      this.status === FundingSearchStatus.awaitingDocuments ||
      this.status === FundingSearchStatus.capitaliseReview
    );
  }

  getValidationRulesForSectionType() {
    return [];
  }

  getFailingRulesForSectionType() {
    return [];
  }

  getMatchByEntityId() {
    return null;
  }
}
